export const getQueryElement = (): HTMLTextAreaElement => {
    const element = document.getElementById('graphql-query') as HTMLTextAreaElement;
    if (!element) throw new Error('Query element not found');
    return element;
};

export const getContentElement = (): HTMLDivElement => {
    const element = document.getElementById('main-content') as HTMLDivElement;
    if (!element) throw new Error('Content element not found');
    return element;
};
